import type { Store } from '@ps/web-core-store';
import { useStore } from 'react-redux';

import type { InjectedValidatorProps } from '../../hoc/withValidator';
import { trackingTranslation } from '../../locales/locales';

export const useErrorLabels = (
  validationErrors: InjectedValidatorProps['validationErrors'] = []
) => {
  const store = useStore() as Store;

  return validationErrors
    .filter((error) => !error.valid)
    .map(({ message }) => trackingTranslation(message, store))
    .filter(Boolean) as string[];
};

export default useErrorLabels;
